import { render, staticRenderFns } from "./MdSpinner.vue?vue&type=template&id=4729b785"
import script from "./MdSpinner.vue?vue&type=script&lang=js"
export * from "./MdSpinner.vue?vue&type=script&lang=js"
import style0 from "./MdSpinner.vue?vue&type=style&index=0&id=4729b785&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports